import { Map } from 'immutable';

import User from './scenes/User';
import UserDetails from './scenes/User/details';
import UserAdd from './scenes/User/add';
import SDM17SPG from './scenes/SDM17SPG';
import SDM17SPGDetails from './scenes/SDM17SPG/details';
import SDM17DEC from './scenes/SDM17DEC';
import SDM17DECDetails from './scenes/SDM17DEC/details';
import Issues from './scenes/Issues';
import IssueDetails from './scenes/Issues/details';
import IssueCreate from './scenes/Issues/create';

export default new Map({
    /** User */
    '/user': {
        firstPage: true,
        must_logged: true,
        component: User,
        right: 'userList',
        children: new Map({
            /* User Add */
            '/add': {
                index: 1,
                must_logged: true,
                component: UserAdd,
                right: 'userAdd'
            },
            /** User Detail */
            '/detail/:userId': {
                must_logged: true,
                component: UserDetails,
                right: 'userDetails'
            }
        })
    },
    /** Remote */
    '/SDM17DEC': {
        must_logged: true,
        component: SDM17DEC,
        right: 'SDM17DECList',
        children: new Map({
            /** SDM17DEC Detail */
            '/detail/:SDM17DECId': {
                must_logged: true,
                component: SDM17DECDetails,
                right: 'SDM17DECDetails'
            }
        })
    },

    /** SDM17SPGs */
    '/SDM17SPG': {
        must_logged: true,
        component: SDM17SPG,
        right: 'SDM17SPGList',
        children: new Map({
            /** SDM17SPG Detail */
            '/detail/:SDM17SPGId': {
                must_logged: true,
                component: SDM17SPGDetails,
                right: 'SDM17SPGDetails'
            }
        })
    },

    '/issues': {
        must_logged: true,
        component: Issues,
        right: 'issuesList',
        children: new Map({
            '/:issueId/projects/:projectId': {
                must_logged: true,
                component: IssueDetails,
                right: 'issueDetails'
            },
            '/create': {
                must_logged: true,
                component: IssueCreate,
                right: 'issueCreate'
            }
        })
    }
});



// WEBPACK FOOTER //
// ./environments/fhepool/routes.js